<template>
	<div class="v-comment-item">
		<div class="avatar">
			<img :src="item.avatar?item.avatar:'/static/img/no-avatar.png'" :alt="item.nickname">
		</div>
		<div class="user">
			<span class="nickname">{{item.nickname}}</span>
			<span class="countdown" v-if="item.countdown == 0">刚刚</span>
			<span class="countdown" v-else>{{item.countdown}}前</span>
			<span class="region-text">{{item.region}}</span>
		</div>
		<div class="content" v-html="$options.filters.atuser(item.content)"></div>
		<div class="toolbar">
			<div class="pull-right" v-if="item.reply_id==0 && item.reply_num>0">
				<a href class="btn-reply" @click.prevent="eShowReplyList">
					<span v-if="showReplyList">
						收起回复 ({{item.reply_num}})
						<i class="fa fa-angle-down"></i>
					</span>
					<span v-else>
						查看回复 ({{item.reply_num}})
						<i class="fa fa-angle-up"></i>
					</span>
				</a>
			</div>

			<Like ref-type="user_comment" :ref-id="item.id" :init-num="item.like_num"/>
			<a href @click.prevent="eShowReplyPost">
				<i class="fa fa-commenting-o"></i> 回复
			</a>
			<span v-if="user && (user.is_admin != 0 || user.id == item.user_id)">
				<a href @click.prevent="deleteItem(item.id)">
					<i class="fa fa-trash"></i> 删除
				</a>
			</span>
		</div>
		<div class="reply">
			<div class="v-comment-post" v-if="showReplyPost">
				<Post
					:ref-type="refType"
					:ref-id="refId"
					:reply-id="item.reply_id != 0 ? item.reply_id : item.id"
					:at-user="item.nickname"
					@hidePost="showReplyPost = 0"
				/>
			</div>
			<div class="v-comment-list" v-if="showReplyList && item.reply_num > 0">
				<Item
					v-for="reply in item.replys"
					:ref-type="refType"
					:ref-id="refId"
					:item="reply"
					:user="user"
					:key="reply.id"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Like from "@/components/Like";
import Post from "@/components/Comment/Post";

export default {
	name: "Item",
	components: { Like, Comment, Post },
	props: ["refType", "refId", "isReply", "item", "user"],
	data() {
		return {
			showReplyList: 1,
			showReplyPost: 0
		};
	},
	filters: {
		atuser(val) {
			return val.replace(/(@[^\s]+\s?)/g, '<i class="atuser">$1</i> ')
		}
	},
	methods: {
		eShowReplyPost() {
			if (!this.$store.getters.user) {
				return this.util.$emit("login");
			}
			this.showReplyPost = !this.showReplyPost;
		},
		eShowReplyList() {
			this.showReplyList = !this.showReplyList;
		},
		deleteItem(id) {
			this.$message.closeAll()
			this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.axios
						.get(this.axios.apiGateway + "comment/delete", {
							params: {
								id: id,
								token: this.user.token
							}
						})
						.then(res => {
							if (res.data.errcode) {
								this.$message.error(res.data.errmsg)
							} else {
								this.util.$emit("reloadCommentList", 0, res => {
									this.$message.success("评论删除成功！")
								})
							}
						})
				})
				.catch(() => {
					this.$message.info("已取消删除");
				});
		}
	}
};
</script>

<style lang="less">
.v-comment-item {
	position: relative;
	padding: 20px 20px 20px 60px;
	border-bottom: solid 1px #f0f0f0;
	font-size: 1.1rem;
	&:last-child {
		border-bottom: none;
	}
	.region-text {
		float: right;
		opacity: .3;
	}
	.avatar {
		position: absolute;
		left: 20px;
		width: 30px;
		height: 30px;
		line-height: 36px;
		border: none;
		border-radius: 100%;
		overflow: hidden;
		background: #f0f0f0;
		img {
			display: block;
			width: 100%;
			height: 100%;
			border: none;
		}
	}
	.user {
		padding: 5px 0;
		.nickname {
			font-weight: bold;
		}
		.countdown {
			color: #888;
			margin-left: 15px;
		}
	}
	.content {
		line-height: 1.8em;
		margin: 10px 0 20px 0;
		.atuser {
			color: #0164bb;
		}
	}
	.toolbar {
		a {
			margin-right: 10px;
			color: #777;
		}
		.btn-reply {
			color: rgb(4, 47, 121);
			margin: 0;
		}
	}
	.reply {
		.v-comment-post {
			margin-top: 15px;
		}
		.v-comment-list {
			margin-top: 20px;
			background: #fff;
			border: solid 1px #f0f0f0;
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Comment/Item.vue